import { Popover, Typography, Box } from "@mui/material";
import { PopoverProps } from "@mui/material/Popover";
import { FC, MouseEventHandler, ReactNode } from "react";
import Button, { ButtonKind, ButtonSize } from "../../Buttons/Button/Button";
import styles from "./InfoTooltip.module.css"

export type InfoTooltipProps = {
  anchorEl: PopoverProps["anchorEl"];
  open: boolean;
  onClose: () => void;
  text: ReactNode;
  darkBackground: boolean,
  hover?: boolean
  buttonLabel?: string;
  onAction?: MouseEventHandler<HTMLButtonElement>;
  anchorOrigin?: PopoverProps["anchorOrigin"];
  transformOrigin?: PopoverProps["transformOrigin"];
  enablePointerEvents?: boolean
};

const InfoTooltip: FC<InfoTooltipProps> = ({
  anchorEl,
  open,
  onClose,
  text,
  buttonLabel = "Action",
  hover = false,
  onAction,
  darkBackground = false,
  enablePointerEvents = false,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' },
  transformOrigin = { vertical: 'top', horizontal: 'center' }
}) => {

  function handleClose() {
    onClose()
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      disableRestoreFocus
      className={`${styles.popover} ${darkBackground ? styles.darkBackground : ''} ${hover ? styles.hover : ''} ${enablePointerEvents ? styles.enablePointerEvents : ''}`}
      data-testid="InfoTooltip"
    >
      <Box p={2} className={styles.tooltipBox}>
        <Typography variant="body2" mb={1} data-testid="InfoTooltip">
          {text}
        </Typography>

        <Button
          size={ButtonSize.SMALL}
          kind={ButtonKind.SUGGESTED}
          data-testid="InfoTooltip_Button"
          onClick={(e) => {
            onAction?.(e);
            onClose();
          }}
        >
          {buttonLabel}
        </Button>
      </Box>
    </Popover>
  );
};

export default InfoTooltip;